import { useI18n } from "@wordpress/react-i18n";
import React from "react";
/**
 * PRIVALO BUTI FORMOJE
 * @param isSubmitting formos onSubmit flagas
 * */
export function EmailSubmit({ id, text, error, placeholder, isSubmitting, onChange, value, button_color }) {
    const { __ } = useI18n();
    const htmlFor = id + '-email-submit';
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: htmlFor }, __("El. pašto adresas", 'ltg-widgets')),
        React.createElement("div", { className: "ltg-email-submit-wrap" },
            React.createElement("input", { type: "email", id: htmlFor, value: value, placeholder: placeholder, style: { borderColor: !!error ? 'red' : null }, onChange: ({ target }) => {
                    onChange && onChange(target.value);
                } }),
            React.createElement("button", { className: `ltg-email-submit btn btn-${button_color || 'primary'}`, disabled: isSubmitting }, text)),
        error && (React.createElement("div", { className: "ltg-email-submit-error" }, error))));
}
